import type { MarketingReportFieldsResponse } from "@/shared/api/generated/types/marketing"
import { MarketingReportFieldKey } from "@/shared/api/generated/types/marketing"

export const marketingReportFieldsFixture: MarketingReportFieldsResponse = {
	fields: [
		{ key: MarketingReportFieldKey.fio, label: "ФИО пациента" },
		{ key: MarketingReportFieldKey.phone, label: "Телефон" },
		{ key: MarketingReportFieldKey.birthday, label: "Дата рождения" },
		{ key: MarketingReportFieldKey.email, label: "E-mail" },
		{ key: MarketingReportFieldKey.passport, label: "Паспорт" },
		{ key: MarketingReportFieldKey.last_doctor, label: "Последний врач" },
		{ key: MarketingReportFieldKey.last_service, label: "Последняя услуга" },
		{
			key: MarketingReportFieldKey.last_visit_date,
			label: "Дата последнего визита",
		},
	],
}

export const DEFAULT_EXPORT_FIELD_KEYS = [
	MarketingReportFieldKey.fio,
	MarketingReportFieldKey.phone,
	MarketingReportFieldKey.last_visit_date,
] as const
